import { api } from '../config/api';
import { SearchResult } from '../data/types/services';

export const locationAPIService = {
  /**
   * Search for locations (countries and cities) based on a search term
   * @param searchTerm - The term to search for
   * @returns Promise containing the search results
   */
  searchLocations: async (searchTerm: string): Promise<SearchResult> => {
    try {
      const { data } = await api.post<SearchResult>('/countries-cities', {
        searchTerm,
      });
      return data;
    } catch (error) {
      console.error('Error searching locations:', error);
      throw new Error('Failed to search locations');
    }
  },
}; 